module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAA9ElEQVR4Ae3VscnDMBAFYG2gHdx6hb//XaT1GiZDaAHVBo+lEbSEC0WGJ3JcfBF54M4HrxF6+eCCbff/fHyklDLWJGQ8u8P2rGIs74kGQPRscBXF1USI3nHJ1/wh3irKey1Ezzvsu830pTgVNUQvHQe7OJhxKYizgLNZK0zPqaJcQ0DUujBkT4N7W48M1rJrhek5oxzFHx0NjOq5cv3cID25ZkHy1WCWL2ugBEhgAAMBkhiePQrEaoaaYGCDhTFgUj+2dLC5YRSIstcohf0AphPUk1gHxGiUwjRIoBrjwQ46EBgNFiCZcFgQaGfuz9NGrImd7QV784Nqz2YwtQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/sign.png
// module id = soWF
// module chunks = 215